(function () {
  'use strict';

  var ROOT = '[data-taupe-marquee-root]';
  var TOP_THRESHOLD = 8;
  var TRANSITION = 'height 0.4s cubic-bezier(0.4, 0, 0.2, 1)';

  function scrollTop() {
    return window.scrollY || document.documentElement.scrollTop || document.body.scrollTop || 0;
  }

  function syncHeaderHeight() {
    var stickyHeader = document.querySelector('sticky-header');
    if (stickyHeader && typeof stickyHeader.setHeaderHeight === 'function') {
      stickyHeader.setHeaderHeight();
    }
  }

  function initMarqueeScroll() {
    var root = document.querySelector(ROOT);
    if (!root || document.body.classList.contains('taupe-landing')) return;

    var section = root.closest('.shopify-section');
    if (!section || section.dataset.taupeMarqueeReady === 'true') return;
    section.dataset.taupeMarqueeReady = 'true';

    var headerGroup = section.closest('.shopify-section-group-header-group');
    var expandedHeight = 0;
    var isCollapsed = scrollTop() > TOP_THRESHOLD;

    section.style.overflow = 'hidden';
    section.style.minHeight = '0';
    section.style.transition = TRANSITION;

    function measureHeight() {
      var prev = section.style.transition;
      section.style.transition = 'none';
      section.classList.remove('is-scroll-hidden');
      root.classList.remove('is-scroll-hidden');
      section.style.height = 'auto';
      expandedHeight = section.offsetHeight;
      section.style.transition = prev || TRANSITION;

      if (headerGroup) {
        headerGroup.style.setProperty('--taupe-marquee-height', expandedHeight + 'px');
      }

      return expandedHeight;
    }

    function setHeight(px, animate) {
      if (!animate) section.style.transition = 'none';
      section.style.height = px + 'px';

      if (headerGroup) {
        headerGroup.style.setProperty('--taupe-marquee-live-height', px + 'px');
      }

      if (!animate) {
        requestAnimationFrame(function () {
          section.style.transition = TRANSITION;
        });
      }
    }

    function setCollapsed(collapsed, animate) {
      isCollapsed = collapsed;
      section.classList.toggle('is-scroll-hidden', collapsed);
      root.classList.toggle('is-scroll-hidden', collapsed);

      if (headerGroup) {
        headerGroup.classList.toggle('is-marquee-collapsed', collapsed);
      }

      root.setAttribute('aria-hidden', collapsed ? 'true' : 'false');
      setHeight(collapsed ? 0 : expandedHeight, animate);
      syncHeaderHeight();
    }

    function onScroll() {
      var atTop = scrollTop() <= TOP_THRESHOLD;
      if (atTop === !isCollapsed) return;
      setCollapsed(!atTop, true);
    }

    section.addEventListener('transitionend', function (e) {
      if (e.target === section && e.propertyName === 'height') {
        syncHeaderHeight();
      }
    });

    measureHeight();
    setCollapsed(isCollapsed, false);

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener(
      'resize',
      function () {
        measureHeight();
        setCollapsed(isCollapsed, false);
      },
      { passive: true }
    );

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () {
        measureHeight();
        setCollapsed(isCollapsed, false);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMarqueeScroll);
  } else {
    initMarqueeScroll();
  }

  document.addEventListener('shopify:section:load', initMarqueeScroll);
})();
